import { render, staticRenderFns } from "./ActionText.vue?vue&type=template&id=220a70c2&scoped=true"
import script from "./ActionText.vue?vue&type=script&lang=ts"
export * from "./ActionText.vue?vue&type=script&lang=ts"
import style0 from "./ActionText.vue?vue&type=style&index=0&id=220a70c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a70c2",
  null
  
)

export default component.exports